// 工单
export const WORKORDER = 'WORKORDER'

// 控件
export const CONTROL = 'CONTROL'

// 清除工单和控件
export const CLEARCONTROL = 'CLEARCONTROL'

// 通过控件改变工单
export const CONTROLWORKORDE = 'CONTROLWORKORDE'
